import React, { Component } from "react";
import { Paper, Box, Typography, Chip } from '@mui/material';
import { ShoppingCart, Info } from '@mui/icons-material';

import ClientAPI from "../service/ClientAPI";
import AdminAPI from "../service/AdminAPI";
import LocalStorageManager from "../managers/LocalStorageManager";
import MyProductsTable from "../components/MyProductsTable";

import 'react-calendar/dist/Calendar.css';

class Dashboard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            products: [],
            allOrders: [],
            searchUserInTable: null,
            searchProduct: null,
            searchUser: null,
            userOrders: [],
            showDateTable: false,
            updateStartDate: false,
            updateEndDate: false,
            startDate: props.start,
            endDate: props.end,
            downloadingExcel: false
        };

        this.isAdmin = LocalStorageManager.Get("admin") === "1";
    }

    componentDidMount() {
        if (!this.isAdmin) {
            ClientAPI.GetOrders()
                .then((_orders) => {
                    this.setState({ userOrders: _orders });
                })
                .catch(console.error);

            return;
        }

        ClientAPI.RequestProducts()
            .then((_data) => {
                AdminAPI.FetchUserOrders()
                    .then(_allOrders => {
                        ClientAPI.GetOrders()
                            .then(_orders => {
                                this.setState({ products: _data, allOrders: _allOrders, userOrders: _orders })
                            })
                    })
                    .catch(console.error);
            })
            .catch(console.error);
    }

    RenderProductsOfUser = (admin = false) => {
        return (
            <div style={{ 
                maxWidth: window.innerWidth < 600 ? "95%" : "80%", 
                margin: window.innerWidth < 600 ? "15px auto" : "30px auto"
            }}>
                {/* Shopping Cart Header */}
                <Box sx={{ mb: { xs: 3, sm: 4 }, textAlign: 'center' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: { xs: 1.5, sm: 2 }, mb: { xs: 1.5, sm: 2 }, flexWrap: 'wrap' }}>
                        <ShoppingCart sx={{ fontSize: { xs: '2rem', sm: '3rem' }, color: '#2e7d32' }} />
                        <Typography 
                            variant="h3" 
                            sx={{ 
                                fontWeight: 700,
                                color: "#2e7d32",
                                fontSize: { xs: '1.75rem', sm: '2.5rem', md: '3rem' }
                            }}
                        >
                            Mein Warenkorb
                        </Typography>
                    </Box>
                    <Typography variant="body1" sx={{ color: '#666', fontSize: { xs: '0.95rem', sm: '1.1rem' } }}>
                        {this.state.userOrders.length === 0 
                            ? "Ihr Warenkorb ist leer" 
                            : `${this.state.userOrders.length} ${this.state.userOrders.length === 1 ? 'Artikel' : 'Artikel'} in Ihrem Warenkorb`}
                    </Typography>
                </Box>

                <MyProductsTable orders={this.state.userOrders} />
            </div>
        );
    }

    render() {
        return (
            this.isAdmin ? (
                this.RenderProductsOfUser(true)
            )
                :
                <div style={{ minHeight: "95vh", paddingTop: window.innerWidth < 600 ? "15px" : "30px" }}>
                    {/* Info Box for Customers */}
                    <Box sx={{ maxWidth: window.innerWidth < 600 ? "95%" : "80%", margin: window.innerWidth < 600 ? "0 auto 20px" : "0 auto 30px" }}>
                        <Paper
                            elevation={3}
                            sx={{
                                borderRadius: '12px',
                                overflow: 'hidden',
                                border: '2px solid #e3f2fd'
                            }}
                        >
                            {/* Header */}
                            <Box
                                sx={{
                                    background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
                                    p: { xs: 1.5, sm: 2 },
                                    color: 'white',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: { xs: 1, sm: 1.5 }
                                }}
                            >
                                <Info sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }} />
                                <Typography variant="h6" sx={{ fontWeight: 600, fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                                    Wichtige Hinweise zur Bestellung
                                </Typography>
                            </Box>

                            <Box sx={{ p: { xs: 2, sm: 3 } }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                    <Box>
                                        <Chip 
                                            label="Schritt 1" 
                                            size="small" 
                                            sx={{ 
                                                bgcolor: '#2e7d32', 
                                                color: 'white', 
                                                fontWeight: 600,
                                                mb: 1 
                                            }} 
                                        />
                                        <Typography variant="body1" sx={{ color: '#333' }}>
                                            Fügen Sie Produkte zu Ihrem Warenkorb hinzu
                                        </Typography>
                                    </Box>

                                    <Box>
                                        <Chip 
                                            label="Schritt 2" 
                                            size="small" 
                                            sx={{ 
                                                bgcolor: '#2e7d32', 
                                                color: 'white', 
                                                fontWeight: 600,
                                                mb: 1 
                                            }} 
                                        />
                                        <Typography variant="body1" sx={{ color: '#333' }}>
                                            Wählen Sie die Bestellungen aus, die Sie bestätigen möchten (Klicken Sie auf die Produkte)
                                        </Typography>
                                    </Box>

                                    <Box>
                                        <Chip 
                                            label="Schritt 3" 
                                            size="small" 
                                            sx={{ 
                                                bgcolor: '#2e7d32', 
                                                color: 'white', 
                                                fontWeight: 600,
                                                mb: 1 
                                            }} 
                                        />
                                        <Typography variant="body1" sx={{ color: '#333' }}>
                                            Klicken Sie auf <strong>"Bestätigen"</strong> um Ihre Bestellung abzuschließen
                                        </Typography>
                                    </Box>

                                    <Box 
                                        sx={{ 
                                            bgcolor: '#fff3cd', 
                                            border: '1px solid #ffc107',
                                            borderRadius: '8px',
                                            p: 2,
                                            mt: 1
                                        }}
                                    >
                                        <Typography variant="body2" sx={{ color: '#856404', fontWeight: 500 }}>
                                            ⚠️ <strong>Wichtig:</strong> Bestätigte Bestellungen können nicht mehr bearbeitet werden. 
                                            Sie können auch keine weiteren Produkte dieser Art hinzufügen!
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Paper>
                    </Box>

                    {this.RenderProductsOfUser()}
                </div>
        )
    }
}

export default Dashboard;